import styled from "styled-components";
import {styledByTheme} from "../../../../../../themes/architecture/styled-by-theme";

export const GenericSideMenuItemLabelDefaultBox = styled.span`
    flex: 1 0 auto;
`;

const GenericSideMenuItemLabelCasino888Box = styled(GenericSideMenuItemLabelDefaultBox)`
    @media ${({theme}) => theme.mediaQuery.lAndAbove} {
        flex: 0 0 auto;
        line-height: 1.3;
        width: 12.5rem;
    }
`

export const GenericSideMenuItemLabelBox = styledByTheme(GenericSideMenuItemLabelDefaultBox)
    .forCasino888(GenericSideMenuItemLabelCasino888Box)
    .apply();